import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Input } from 'shared/components';
import { MATERIAL_SERIAL_NUMBER_LENGTH } from 'shared/constants';

class EquatingSeat extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  handleChange(e) {
    const value = e.target.value;
    this.props.handleClick(value ? value : '');
  }

  handleBlur(e) {
    const value = e.target.value;
    this.props.handleClick(value ? value : '');
    this.props.handleBlur();
  }

  render() {
    const { data, cellKey } = this.props;

    return (
      <div className="cell equating">
        <Input
          type="number"
          name={`serial-number-input${cellKey}`}
          label={this.props.t('seatingChart.assign.equatingInputLabel')}
          value={data.serialNumber}
          errors={data.error}
          maxLength={MATERIAL_SERIAL_NUMBER_LENGTH}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onAddonAction={this.maxLength}
        />
      </div>
    );
  }
}

export default withTranslation()(EquatingSeat);
EquatingSeat.propTypes = {
  data: PropTypes.shape({}).isRequired,
  handleClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
